import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandBgDeleteEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandBgDeleteEventDTO.validationSchema()
  );

  constructor(readonly data: RoomBrandBgDeleteEvent) {
    JsonSchemaValidator.assert(RoomBrandBgDeleteEventDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      }
    };
  }
}

interface RoomBrandBgDeleteEvent {
  roomId: RoomId;
}
